<template>
  <div class="d-flex align-items-center justify-content-center">
    <!-- 尚未錄音 -->
    <div class="inline-block w-auto h-auto rounded-circle border_main4 p-2" v-if="(!isRecording && !isPostingRecord) || selectedIdx !== itemIndex">
      <div>
        <img src="@/assets/image/gept/startRecord_btn_read.png" alt="" class="object-contain">
      </div>
    </div>

    <!-- 錄音中 -->
    <div class="d-flex rounded-circle border_main4 align-items-center" v-if="isRecording && !isPostingRecord">
      <div class="item_img d-flex justify-content-center">
        <div class="rounded-circle p-2">
          <div class="record_img">
            <canvas id="canvas" ref="recordRef" class="canvas canvas_Recognition"></canvas>
          </div>
        </div>
      </div>
      <a class="voice_stop opacity-50" v-if="!canStop">
        <img src="@/assets/image/gept/stop_btn_read.png" alt="" class="">
      </a>
      <a class="voice_stop pointer" @click.prevent="stopRecord()" v-else>
        <img src="@/assets/image/gept/stop_btn_read.png" alt="" class="">
      </a>
    </div>

    <!-- 錄音結束 -->
    <div class="pointer inline-block w-auto h-auto rounded-circle border_main4 p-2" v-if="isPostingRecord && selectedIdx === itemIndex">
      <img src="@/assets/image/gept/read_loading.png" alt="" class="object-contain onreconation_icon">
    </div>
  </div>
</template>

<script>
  import api from '@/store/api'
  import Recorder from 'js-audio-recorder'
  import { mapGetters } from 'vuex'
  import recordingBgSrc from '@/assets/image/gept/recording_img3.png' // 改名更清楚

  export default {
    name: "RecognitionS",
    props: {
      itemIndex: { type: Number, default: -1 },
      selectedIdx: { type: Number, default: -1 },
      isPostingRecord: { type: Boolean, default: false },
      isCanActive: { type: Boolean, default: false }
    },
    data () {
      return {
        isImageLoading: false,
        drawRecordId: null,
        canStop: false,
        isRecording: false,
        isInitializing: false, // 新增：防止重複初始化
        recorderJS: null,
        bgImage: null, // 新增：快取背景圖
        ctx: null // 新增：快取 Canvas Context
      }
    },
    computed: {
      ...mapGetters(['remainPoints'])
    },
    watch: {
      selectedIdx: {
        immediate: true,
        handler (newVal) {
          if (newVal === this.itemIndex && !this.recorderJS && !this.isRecording) {
            this.safeInitMediaDevices()
          } else if (newVal !== this.itemIndex && this.isRecording) {
            this.stopRecord()
          }
        }
      },
      isCanActive (newVal) {
        if (!newVal) {
          this.stopRecord()
        }
      }
    },
    mounted () {
      this.initCanvasResources()
    },
    beforeDestroy () {
      this.cleanupRecorder()
    },
    methods: {
      // 1. 初始化 Canvas 資源 (只執行一次)
      initCanvasResources () {
          const canvas = this.$refs.recordRef
          // 如果找不到 canvas 元素 (可能還在 v-if 隱藏中)，就直接結束，等下次 drawWave 再試
          if (!canvas) return false 

          // 設定解析度 (只需設定一次)
          if (canvas.width !== 50) {
              canvas.width = 50
              canvas.height = 50
          }

          // 取得 Context
          if (!this.ctx) {
              this.ctx = canvas.getContext('2d')
          }

          // 處理背景圖 (如果還沒開始載入才載入)
          if (!this.bgImage && !this.isImageLoading) {
            this.isImageLoading = true // 新增一個標記防止重複載入
            const img = new Image()
            img.src = recordingBgSrc
            img.onload = () => {
              this.bgImage = img
              this.isImageLoading = false
            }
          }
          return true
        },

      async safeInitMediaDevices () {
        if (this.isInitializing) return
        this.isInitializing = true

        try {
          // 請求權限
          await navigator.mediaDevices.getUserMedia({ audio: true })
          // AudioContext 的處理 (視需求保留，但建議加上 try-catch 包裹更嚴謹)
          // 如果只是為了喚醒 AudioEngine，通常 getUserMedia 成功後就足夠了
          // 如果確實遇到 iOS Safari 問題，保留此段，但不需要 close
          if (window.AudioContext || window.webkitAudioContext) {
             const AudioContext = window.AudioContext || window.webkitAudioContext;
             const ctx = new AudioContext();
             if (ctx.state === 'suspended') await ctx.resume();
             // ctx.close(); // 頻繁開關可能導致問題，建議讓 GC 處理或保留單例
          }

          this.startRecord()
        } catch (err) {
          this.handleMicError(err)
        } finally {
          this.isInitializing = false
        }
      },

      startRecord () {
        if (this.isRecording) return // 防止重複呼叫

        try {
          // 每次錄音建立新的實例 (如果之前的已銷毀)
          this.recorderJS = new Recorder()
        } catch (err) {
          console.error('[Recorder Init Error]', err)
          this.showMicError('錄音元件初始化失敗')
          return
        }

        this.recorderJS.start()
          .then(() => {
            this.isRecording = true
            this.canStop = false // 重置標記
            this.drawRecord() // 開始繪圖迴圈
          })
          .catch((err) => {
            console.error('[Start Record Error]', err)
            this.showMicError('無法啟動錄音')
            this.cleanupRecorder()
          })

        this.recorderJS.onprogress = (params) => {
          // 建議加上明確的秒數變數，避免 Magic Number
          if (params.duration > 3) {
            this.canStop = true
          }
        }
      },

      stopRecord () {
        // 如果還沒滿足最小錄音長度，通常有兩種作法：
        // 1. 強制停止但丟棄數據
        // 2. 忽略停止請求 (目前邏輯是這樣)
        if (!this.recorderJS || !this.canStop) {
             // 如果需要強制停止(例如切換題目)，即便未滿3秒也要能停，只是不發送數據
             if (!this.isRecording) return; 
             // 這裡視需求決定是否要強制銷毀
             // this.cleanupRecorder(); 
             return 
        }

        try {
          this.recorderJS.stop()
          const audioBlob = this.recorderJS.getWAVBlob()
          if (audioBlob) {
            this.$emit('emitAudioData', audioBlob)
          }
        } catch (err) {
          console.error('[Stop Record Error]', err)
        } finally {
          this.cleanupRecorder()
        }
      },

      // 統一的清理函式
      cleanupRecorder () {
        this.isRecording = false
        this.canStop = false
        
        if (this.recorderJS) {
          try {
            this.recorderJS.destroy()
          } catch (e) { /* ignore */ }
          this.recorderJS = null
        }

        if (this.drawRecordId) {
          cancelAnimationFrame(this.drawRecordId)
          this.drawRecordId = null
        }
      },

      // 優化後的繪圖迴圈
      drawRecord () {
        if (!this.isRecording) return
        this.drawRecordId = requestAnimationFrame(() => this.drawRecord())
        
        // 確保 recorder 存在且有數據
        if(this.recorderJS) {
             this.drawWave(this.recorderJS.getRecordAnalyseData())
        }
      },

      // 優化後的繪製函式：移除 Canvas 大小設定與圖片載入
      drawWave (dataArray) {
          // 關鍵修正：如果 ctx 不存在，嘗試初始化。如果還是失敗，就先不畫。
          if (!this.ctx) {
              const success = this.initCanvasResources()
              if (!success) return
          }

          const width = 50
          const height = 50
          
          // 1. 清除畫布
          this.ctx.clearRect(0, 0, width, height)

          // 2. 繪製背景
          // 如果圖片載入好了就畫圖，還沒好就畫一個暫時的底色，避免畫面全白
          if (this.bgImage) {
            this.ctx.drawImage(this.bgImage, 0, 0, width, height)
          } else {
            this.ctx.fillStyle = 'rgb(200, 200, 200)' // 暫時底色
            this.ctx.fillRect(0, 0, width, height)
          }

          // 3. 繪製波形
          const bufferLength = dataArray.length
          const sliceWidth = width / bufferLength

          this.ctx.lineWidth = 2
          this.ctx.strokeStyle = 'rgb(255, 255, 255)'
          this.ctx.beginPath()

          let x = 0
          for (let i = 0; i < bufferLength; i++) {
            const v = dataArray[i] / 128.0
            const y = v * height / 2

            if (i === 0) {
              this.ctx.moveTo(x, y)
            } else {
              this.ctx.lineTo(x, y)
            }
            x += sliceWidth
          }

          this.ctx.lineTo(width, height / 2)
          this.ctx.stroke()
        },

      handleMicError (err) {
        const name = err?.name
        const errorMap = {
          'NotAllowedError': '請點擊網址列左方的鎖頭圖示，並允許存取麥克風。',
          'NotFoundError': '未偵測到麥克風裝置，請確認設備已接上。',
          'NotReadableError': '麥克風可能被其他應用佔用，請稍後再試。',
          'SecurityError': '請使用 HTTPS 網站開啟本功能。'
        }
        this.showMicError(errorMap[name] || '無法啟用麥克風，請確認裝置與瀏覽器設定。')
        if (!errorMap[name]) console.error('[錄音錯誤]', err)
      },

      showMicError (text) {
        this.$swal({
          title: "Notice",
          text: text,
          icon: "warning",
          customClass: { confirmButton: 'btn-submit gept_main_bg' }
        })
      },

      // 改用 Arrow Function (雖然這裡已經不需要 self 了)
      getSTT (audioData) {
        const path = `/ERS?stext=${this.sText}` // 注意：sText 在原始 data 中未定義，請確認
        
        api.request({
          method: 'post',
          url: path,
          headers: { 'Content-Type': 'audio/wave' },
          data: audioData
        })
        .then((response) => {
          this.$emit('emitERS', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
      },

      stopAction () {
        this.$emit('stopAction')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .canvas {
    background-image: url('~@/assets/image/gept/recording_img3.png');
    background-repeat: no-repeat;
    background-size: contain;
  }
  .voice_stop {
    right: 5%;
    bottom: -5%;
    z-index: 2;
  }
  .record_img {
    width: 50px;
    height: 50px;
    background-image: url('~@/assets/image/gept/recording_img3.png');
    background-size: 50px;
  }
  .canvas_Recognition {
    width: 100%;
    height: 100%;
    max-width: 50px;
    max-height: 50px;
  }
  .onreconation_icon {
    transform: translate(-50%, -50%);
    animation: move 2s linear infinite;
    transform-origin: center;
  }
  @keyframes move {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>